export const validateFile = (file: File, supportedExtensions: string[]): boolean => {
  const fileName = file.name.toLowerCase();
  return supportedExtensions.some(ext => fileName.endsWith(ext));
};

export const isFileExtensionOneOf = (fileName: string, extensions: string[]): boolean => {
  const lowerName = fileName.toLowerCase();
  return extensions.some(ext => lowerName.endsWith(ext));
};

export const getVideoDuration = (file: File): Promise<number> => {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.preload = 'metadata';
    video.onloadedmetadata = () => {
      window.URL.revokeObjectURL(video.src);
      resolve(video.duration);
    };
    video.onerror = () => {
      window.URL.revokeObjectURL(video.src);
      reject('Invalid video file');
    };
    video.src = URL.createObjectURL(file);
  });
};

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
};